// @flow

import { decimalFormatter } from '@tectonics/look-and-feel/commons/format-utils';
import { type Country } from '@tectonics/prs/country';
import { type FormatDecimal } from '@tectonics/prs/money';

const DOLLAR_FORMAT = decimalFormatter({
  thousandsSeparator: ',',
  decimalSeparator: '.',
});

const LATAM_FORMAT = decimalFormatter({
  thousandsSeparator: '.',
  decimalSeparator: ',',
});

export function getMoneyFormat(country: Country): FormatDecimal {
  switch (country) {
    case 'mx':
    case 'za':
    case 'ke':
    case 'tz':
    case 'ug':
    case 'zm':
    case 'eg':
    case 'gh':
    case 'jm':
    case 'ng':
    case 'in':
    case 'th':
      return DOLLAR_FORMAT;
    default:
      return LATAM_FORMAT;

  }
}
